module.exports = __webpack_public_path__ + "static/media/ScaleBalenced.7e938bbf.png";